import { render, staticRenderFns } from "./CObjectView.vue?vue&type=template&id=24971888&scoped=true&"
import script from "./CObjectView.vue?vue&type=script&lang=js&"
export * from "./CObjectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24971888",
  null
  
)

export default component.exports